<div [ngClass]="item.class">
    <ds-card class="wallet" [elevated]="true">
        @if (item.image) {
            <div class="wallet__img">
                <vn-image [alt]="item.image.alt" [height]="item.image.height" [src]="item.image.src" [width]="item.image.width"></vn-image>
            </div>
        }
        <ds-card-content>
            <div class="wallet__content">
                <div class="wallet__total">
                    <div class="wallet__total-label ds-label-md">{{ totalBalanceItem?.text }}</div>
                    <div class="wallet__total-value ds-headline-sm-strong">{{ totalBalance | vnCurrency }}</div>
                </div>

                <div class="wallet__list">
                    <div class="wallet__item">
                        <div class="wallet__item-label ds-label-md">{{ withdrawableBalanceItem?.text }}</div>
                        <div class="wallet__item-value ds-title-md-strong">{{ withdrawableBalance | vnCurrency }}</div>
                    </div>

                    <ds-divider class="wallet__item-divider" vertical="true" variant="on-surface-lowest"></ds-divider>

                    <div class="wallet__item">
                        <div class="wallet__item-label ds-label-md">{{ bonusBalanceItem?.text }}</div>
                        <div class="wallet__item-value ds-title-md-strong">{{ bonusBalance | vnCurrency }}</div>
                    </div>
                </div>

                <div class="wallet__details-btn">
                    <button ds-button kind="secondary" variant="outline" size="small" (click)="showBalance()">Balance details</button>
                </div>

                @if (ctaItems?.length) {
                    <div class="wallet__actions">
                        @for (child of ctaItems; track trackByProp($index, child)) {
                            <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
                        }
                    </div>
                }
            </div>
        </ds-card-content>
    </ds-card>
</div>
